module.exports = __webpack_public_path__ + "img/favicon.0a3e87dd.png";